export default __webpack_public_path__ + "static/media/julia.be076220.svg";